import { getPlannerR3F } from '@utils/plannerR3F'

let scheduled = false

/** Un invalidate por frame tras cargas async (frameloop demand). */
export function scheduleInvalidateR3F() {
  if (typeof window === 'undefined' || scheduled) return
  scheduled = true
  requestAnimationFrame(() => {
    scheduled = false
    getPlannerR3F()?.invalidate?.()
  })
}
